{
  "auth": {
    "language": "Язык",
    "powered_by": "Powered by"
  },
  "calendar": {
    "choose_date": "Выберите дату",
    "choose_month": "Выбрать месяц",
    "choose_range": "Выберите период",
    "choose_year": "Выбрать год",
    "clear": "Очистить",
    "max_days": "не более {{count}} дн.",
    "next_month": "Следующий месяц",
    "next_year": "Следующий год",
    "next_years": "Следующие годы",
    "pick_end": "Выберите последний день",
    "pick_start": "Выберите начальный день",
    "previous_month": "Предыдущий месяц",
    "previous_year": "Предыдущий год",
    "previous_years": "Предыдущие годы",
    "today": "Сегодня"
  },
  "change": {
    "down": "Снижение",
    "flat": "Без изменений",
    "unknown": "Нельзя сравнить",
    "up": "Рост"
  },
  "chart": {
    "download": "Скачать",
    "download_excel": "Excel (с текущими фильтрами)",
    "download_png": "Изображение (PNG)",
    "fullscreen": "Во весь экран",
    "table_view": "Табличный вид"
  },
  "close": "Закрыть",
  "color_picker": {
    "choose": "Выбрать цвет {{color}}",
    "contrast_dark": "Тёмный текст: {{ratio}}:1",
    "contrast_fail": "Плохо читается",
    "contrast_pass": "Хорошо читается (WCAG AA)",
    "contrast_white": "Белый текст: {{ratio}}:1",
    "hex": "Код цвета",
    "invalid": "Введите в виде #RRGGBB, например #1F6FD4",
    "palette": "Готовые цвета",
    "swatch": "Выбрать цвет"
  },
  "confirm": {
    "cancel": "Отмена",
    "pending": "Выполняется…",
    "type_name": "Для подтверждения введите «{{name}}»"
  },
  "date_names": {
    "months_long": "январь,февраль,март,апрель,май,июнь,июль,август,сентябрь,октябрь,ноябрь,декабрь",
    "months_of_day": "января,февраля,марта,апреля,мая,июня,июля,августа,сентября,октября,ноября,декабря",
    "months_short": "янв,фев,мар,апр,май,июн,июл,авг,сен,окт,ноя,дек",
    "weekdays_long": "понедельник,вторник,среда,четверг,пятница,суббота,воскресенье",
    "weekdays_short": "Пн,Вт,Ср,Чт,Пт,Сб,Вс",
    "long_date_pattern": "{{weekday}}, {{day}} {{month}} {{year}}"
  },
  "dropzone": {
    "choose": "Выбрать файл",
    "drop_now": "Отпустите файл",
    "empty": "Изображения пока нет",
    "prompt": "Перетащите файл сюда или выберите"
  },
  "image_crop": {
    "cancel": "Отмена",
    "description": "Перетащите изображение, масштабируйте колесом, двумя пальцами или ползунком.",
    "load_failed": "Не удалось открыть изображение. Выберите другой файл PNG или JPG.",
    "loading": "Открываем изображение…",
    "render_failed": "Не удалось подготовить изображение. Попробуйте ещё раз.",
    "save": "Сохранить",
    "shape": "Форма",
    "shape_circle": "Круг",
    "shape_square": "Квадрат",
    "stage_label": "Область обрезки: стрелки двигают, + и − масштабируют",
    "title": "Обрезка изображения",
    "zoom": "Масштаб",
    "zoom_in": "Увеличить",
    "zoom_out": "Уменьшить"
  },
  "image_slot": {
    "optional": "Необязательно",
    "remove": "Удалить",
    "replace": "Заменить",
    "required": "Обязательно"
  },
  "language_name": {
    "en": "English",
    "ru": "Русский",
    "uz": "O'zbekcha"
  },
  "page": {
    "breadcrumb": "Путь к странице"
  },
  "password": {
    "hide": "Скрыть пароль",
    "show": "Показать пароль"
  },
  "period": {
    "apply": "Применить",
    "cancel": "Отмена",
    "choose": "Выбрать период",
    "compare_data_from": "{{range}} (данные с {{date}})",
    "compare_label": "Сравнение",
    "compare_menu": "С чем сравнивать",
    "compare_no_data": "нет данных",
    "compare_option": {
      "none": "Без сравнения",
      "previous_day": "Предыдущий день",
      "previous_days": "Предыдущие {{count}} дн.",
      "previous_month": "Прошлый месяц",
      "previous_months": "Предыдущие {{count}} мес.",
      "previous_week": "Предыдущая неделя",
      "previous_year": "Прошлый год",
      "same_day_last_year": "Тот же день прошлого года",
      "same_period_last_month": "Тот же период прошлого месяца",
      "same_period_last_week": "Тот же период прошлой недели",
      "same_weekday": "Тот же день прошлой недели",
      "year_over_year": "Тот же период прошлого года"
    },
    "date_placeholder": "дд.мм.гггг",
    "day_count": "Дней: {{count}}",
    "from": "Начало",
    "input_end_before_start": "Конец раньше начала",
    "input_future": "Нельзя выбрать будущую дату",
    "input_invalid": "Такой даты нет",
    "next": "Следующий период",
    "preset_custom": "Свой период",
    "preset_last_30_days": "Последние 30 дней",
    "preset_last_7_days": "Последние 7 дней",
    "preset_last_month": "Прошлый месяц",
    "preset_this_month": "Этот месяц",
    "preset_this_year": "Этот год",
    "preset_today": "Сегодня",
    "preset_yesterday": "Вчера",
    "previous": "Предыдущий период",
    "quick_ranges": "Быстрые периоды",
    "to": "Конец"
  },
  "progress": {
    "cancel": "Отменить",
    "remaining": "Осталось: {{time}}"
  },
  "rank": {
    "down": "На {{count}} мест ниже",
    "down_one": "На {{count}} место ниже",
    "down_few": "На {{count}} места ниже",
    "down_many": "На {{count}} мест ниже",
    "medal": "Медаль за {{rank}} место",
    "no_previous": "В прошлом периоде не было в рейтинге (нет данных)",
    "same": "Место не изменилось",
    "up": "На {{count}} мест выше",
    "up_one": "На {{count}} место выше",
    "up_few": "На {{count}} места выше",
    "up_many": "На {{count}} мест выше"
  },
  "select": {
    "clear": "Очистить",
    "count_of_max": "Выбрано {{count}} из {{max}}",
    "count_selected": "Выбрано: {{count}}",
    "no_matches": "Ничего не найдено",
    "search": "Поиск",
    "toggle_group": "все"
  },
  "shell": {
    "collapse_sidebar": "Свернуть меню",
    "expand_sidebar": "Развернуть меню",
    "main_navigation": "Главное меню",
    "more": "Ещё",
    "powered_by": "Powered by {{platform}}",
    "skip_to_content": "Перейти к содержимому"
  },
  "shortcuts": {
    "global": "Везде",
    "help": "Список сочетаний клавиш",
    "search": "Поиск",
    "title": "Сочетания клавиш"
  },
  "state": {
    "empty_title": "Нет данных",
    "error_description": "Проблема с сетью или сервером. Попробуйте ещё раз.",
    "error_title": "Не удалось загрузить данные",
    "loading": "Загрузка…",
    "outages": "Перерывы:",
    "partial": "Неполные",
    "partial_coverage": "Полнота данных: {{percent}}%",
    "retry": "Повторить",
    "stale": "Сервер офлайн — данные получены в {{time}}"
  },
  "table": {
    "columns": "Столбцы",
    "csv": "CSV",
    "filter_placeholder": "Поиск…",
    "more_rows": "Ещё строк: {{count}}. Уточните поиск"
  },
  "tag_input": {
    "remove": "Удалить «{{value}}»"
  },
  "theme": {
    "dark": "Тёмная",
    "light": "Светлая",
    "system": "Как в системе",
    "toggle": "Тема"
  },
  "totp": {
    "code_label": "6-значный код из приложения",
    "confirm": "Подтвердить и включить",
    "digit_label": "Цифра {{number}}",
    "hide_key": "Скрыть ключ",
    "manual_key": "Введите в приложение вручную:",
    "qr_label": "QR-код для приложения-аутентификатора",
    "show_key": "Показать ключ",
    "step_code": "Введите ниже 6-значный код из приложения",
    "step_code_title": "Введите код",
    "step_install": "Google или Microsoft Authenticator (бесплатно)",
    "step_install_title": "Установите приложение на телефон",
    "step_scan": "В приложении нажмите «+» и отсканируйте QR-код",
    "step_scan_title": "Отсканируйте QR-код"
  }
}
